import React from 'react';
import './style.less';
import clsx from 'clsx';
import { LiveListenDelayOptions } from 'types/livelisten';

export const LiveListenStatus = ({
  enabled,
  delay,
}: {
  enabled: boolean;
  delay: LiveListenDelayOptions;
}) => {
  return (
    <div className="LiveListenStatus">
      <div className="LiveListenStatus__statusItem">
        <span className="LiveListenStatus__statusItem-label">Auto-listen</span>

        <span className="LiveListenStatus__statusItem-value">
          <span
            className={clsx(!enabled && 'inactive', 'LiveListenStatus__statusItem-badge')}
          >
            {enabled ? 'ON' : 'OFF'}
          </span>
        </span>
      </div>
      <div className="LiveListenStatus__statusItem">
        <span className="LiveListenStatus__statusItem-label">Joining</span>

        <span className="LiveListenStatus__statusItem-value">
          {delay === LiveListenDelayOptions.DELAY_NONE
            ? 'Immediately'
            : `After ${delay}s`}
        </span>
      </div>
    </div>
  );
};
